import { SalaryDeviationsActionTypes } from "models/actionTypes/salaryDeviationsActionTypes";
import { ReduxConstants } from "utils/constants";

export const salaryDeviationSubmitted = (id: number): SalaryDeviationsActionTypes => {
  return {
    type: ReduxConstants.SalaryDeviationsActions.SALARY_DEVIATIONS_SUBMITTED,
    payload: id,
  };
};

export const salaryDeviationWithBusinessUnitsSubmitted = (id: number): SalaryDeviationsActionTypes => {
  return {
    type: ReduxConstants.SalaryDeviationsActions.SALARY_DEVIATIONS_WITH_BUSINESSUNITS_SUBMITTED,
    payload: id,
  };
};

export const wintSalaryDeviationsSubmitted = (id: number): SalaryDeviationsActionTypes => {
  return {
    type: ReduxConstants.SalaryDeviationsActions.WINT_SALARY_APPROVAL_REPORT_SUBMITTED,
    payload: id,
  };
};
